import TrackingUtils from "./tracking-utils";

(function(ss) {
  var quantityTypes = { single: 'SINGLE', bulk: 'BATCH'};

  var organizeActions = {
    add: 'ADD',
    copy: 'COPY',
    reclip: 'RECLIP',
    move: 'MOVE',
    remove: 'REMOVE',
    reorder: 'REORDER'
  };

  var events = {
    SlideShareClipActionEvent: "SlideShareClipActionEvent",
    SlideShareClipOrganizeActionEvent: "SlideShareClipOrganizeActionEvent",
    SlideShareClipboardActionEvent: "SlideShareClipboardActionEvent",
    SlideShareClippingClickEvent: "SlideShareClippingClickEvent",
    SlideShareClippingShareEvent: "SlideShareClippingShareEvent",
    SlideShareClippingViewEvent: "SlideShareClippingViewEvent"
  };

  var organizeEvents = {
    addSingleClip: { quantityType: quantityTypes.single, actionType: organizeActions.add },
    copySingleClip: { quantityType: quantityTypes.single, actionType: organizeActions.copy },
    reclipSingleClip: { quantityType: quantityTypes.single, actionType: organizeActions.reclip },
    moveSingleClip: { quantityType: quantityTypes.single, actionType: organizeActions.move },
    removeSingleClip: { quantityType: quantityTypes.single, actionType: organizeActions.remove },
    reorderSingleClip: { quantityType: quantityTypes.single, actionType: organizeActions.reorder },
    addMultipleClips: { quantityType: quantityTypes.bulk, actionType: organizeActions.add },
    copyMultipleClips: { quantityType: quantityTypes.bulk, actionType: organizeActions.copy },
    reclipMultipleClips: { quantityType: quantityTypes.bulk, actionType: organizeActions.reclip },
    moveMultipleClips: { quantityType: quantityTypes.bulk, actionType: organizeActions.move },
    removeMultipleClips: { quantityType: quantityTypes.bulk, actionType: organizeActions.remove },
    reorderMultipleClips: { quantityType: quantityTypes.bulk, actionType: organizeActions.reorder }
  };

  var clickEvents = {
    clickClipButton: 'CLIP',
    clickViewToGrid: 'CHANGE_VIEW_TO_GRID',
    clickViewToList: 'CHANGE_VIEW_TO_LIST',
    clickTopNavMyClipboards: 'CLIPBOARDS_NAV',
    clickClipThumbnail: 'CLIP_THUMBNAIL',
    clickProfileMyClipboards: 'PROFILE_DROPDOWN',
    clickShareClip: 'SHARE_CLIP',
    clickShareClipboard: 'SHARE_CLIPBOARD',
    clickSharePrompt: 'SHARE_PROMPT_CTA',
    clickSlideviewTopClipboardsOpen:'SLIDEVIEW_TOP_CLIPBOARDS_OPEN',
    clickTopClipboardsClipboardOwner:'TOP_CLIPBOARDS_MODAL_CLIPBOARD_OWNER',
    clickTopClipboardsClipboardThumb:'TOP_CLIPBOARDS_MODAL_CLIPBOARD_THUMBNAIL',
    clickTopClipboardsClipboardTitle:'TOP_CLIPBOARDS_MODAL_CLIPBOARD_TITLE'
  };

  var entityTypes = {
    clip: 'Clip',
    clipboard: 'Clipboard',
    slideshow: 'Slideshow'
  };

  var shareTypes = {
    directlink: 'DIRECT_LINK',
    email: "EMAIL",
    facebook: "FACEBOOK",
    linkedin: "LINKEDIN",
    pinterest: "PINTEREST",
    twitter: "TWITTER"
  };

  /**
   * Utility for tracking linkedin events for clipping.
   * @param {Object} options
   * @param {String} options.trackingId The tracking id
   * @param {Boolean|null} options.userIsOwner
   *  Flag that indicates whether the logged in user is viewing
   *  his own clips/clipboards
   * @param {String|null} appId An optional app id
   */
  function ClippingTracker(options) {
    this.utils = new TrackingUtils();
    this.pageKey = this.utils.getPageKey();
    this.trackingId = options.trackingId || this.utils.generateTrackingID();
    this.referrerParam = options.referrerParam || 'rftp';
    this.userIsOwner = options.userIsOwner;
    this.appId = options.appId || this.utils.getAppId('clipping');
    this.bodyDefaults = {
      clippingSessionId: this.trackingId,
      requestHeader: {
        pageKey: this.pageKey,
        path: window.document.location.pathname,
        userAgent: navigator && navigator.userAgent,
        referer: document.referrer
      }
    };

  }

  /**
   * Triggers a generic clipping event
   * @param {String} eventName The event name
   * @param {Object} eventBody The event body
   */
  ClippingTracker.prototype.track = function(eventName, eventBody) {
    var eventBody = $.extend({}, this.bodyDefaults, eventBody)
    this.utils.recordTrackingEvent(this.appId, eventName, eventBody);
  };

  /**
   * Triggers a clip action event
   * @param {Object} options
   * @param {String} options.actionType The action type
   * @param {Object} options.clip
   *  The clip object for which this action is triggered
   * @param {String|Integer|null} options.clipboardId
   *  An optional clipboard id associated with this action
   */
  ClippingTracker.prototype.clipAction = function(options) {
    var clip = options.clip;

    return this.track(events.SlideShareClipActionEvent, {
      actionType: options.actionType,
      clipboardUrn: this.utils.getUrn(entityTypes.clipboard,
        options.clipboardId || options.clipboard_id),
      clipUrn: this.utils.getUrn(entityTypes.clip, clip.id),
      slideshowUrn: this.utils.getUrn(entityTypes.slideshow,
        clip.slideshowId || clip.slideshow_id),
      position: clip.position
    });
  };

  /**
   * Triggers a create clip event
   * @param {Object} clip The created clip object
   * @param {Number} clipboardId The id of the clipboard the clip was added to
   */
  ClippingTracker.prototype.createClip = function(clip, clipboardId) {
    return this.clipAction({ actionType: 'CREATE', clip: clip, clipboardId: clipboardId });
  };

  /**
   * Triggers a delete clip event
   * @param {Object} clip The deleted clip object
   */
  ClippingTracker.prototype.deleteClip = function(clip) {
    return this.clipAction({ actionType: 'DELETE', clip: clip });
  };

  /**
   * Triggers a clipboard action event
   * @param {Object} options
   * @param {String} options.actionType The action type
   * @param {Object} options.clipboard
   *  The clipboard object for which this action is triggered
   */
  ClippingTracker.prototype.clipboardAction = function(options) {
    var clipboard = options.clipboard;

    return this.track(events.SlideShareClipboardActionEvent, {
      actionType: options.actionType,
      clipboardUrn: this.utils.getUrn(entityTypes.clipboard, clipboard.id),
      title: clipboard.title,
      isPrivate: clipboard.private
    });
  };

  /**
   * Triggers a create clipboard event
   * @param {Object} clipboard The created clipboard
   */
  ClippingTracker.prototype.createClipboard = function(clipboard) {
    return this.clipboardAction({ actionType: 'CREATE', clipboard: clipboard });
  };

  /**
   * Triggers a delete clipboard event
   * @param {Object} clipboard The deleted clipboard
   */
  ClippingTracker.prototype.deleteClipboard = function(clipboard) {
    return this.clipboardAction({ actionType: 'DELETE', clipboard: clipboard });
  };

  /**
   * Triggers an edit clipboard event
   * @param {Object} newClipboard The changed clipboard
   * @param {Object} oldClipboard The original clipboard
   */
  ClippingTracker.prototype.editClipboard = function(newClipboard, oldClipboard) {
    var clipboard = { id: newClipboard.id };

    Object.keys(newClipboard).forEach(function(k) {
      if (newClipboard[k] !== oldClipboard[k]) {
        clipboard[k] = newClipboard[k];
      }
    });

    return this.clipboardAction({ actionType: 'EDIT', clipboard: clipboard });
  };

  /**
   * Triggers a page view event
   * @param {Number|null} clipboardId An optional clipboard id
   */
  ClippingTracker.prototype.pageView = function(clipboardId) {
    return this.track(events.SlideShareClippingViewEvent, {
      clipboardUrn: this.utils.getUrn(entityTypes.clipboard, clipboardId),
      isOwner: this.userIsOwner,
      referrerType: (window.getUrlVar(this.referrerParam) || '').toUpperCase()
    });
  };

  /**
   * Triggers a clip organize event
   * @param {Object} options The event options
   * @param {String} options.actionType The action type
   * @param {String} options.quantityType The quantity type
   * @param {Array} options.clipIds The clip ids
   * @param {Number|null} options.sourceClipboardId An optional source clipboard id
   * @param {Number|null} options.targetClipboardId An optional target clipboard id
   */
  ClippingTracker.prototype.clipOrganizeAction = function(options) {
    return this.track(events.SlideShareClipOrganizeActionEvent, {
      actionType: options.actionType,
      quantityType: options.quantityType,
      clipUrns: options.clipIds.map(this.utils.getUrn.bind(null, entityTypes.clip)),
      sourceClipboardUrn: this.utils.getUrn(entityTypes.clipboard,
        options.sourceClipboardId),
      targetClipboardUrn: this.utils.getUrn(entityTypes.clipboard,
        options.targetClipboardId)
    });
  };

  /**
   * Triggers a specific share event
   * @param {Number} entity The id of the entity being shared
   * @param {String} stareType The type of share
   */
  [ entityTypes.clip, entityTypes.clipboard ].forEach(function(entityType) {
    ClippingTracker.prototype['share' + entityType] = function(entityId, shareType) {
      return this.track(events.SlideShareClippingShareEvent, {
        entityUrn: this.utils.getUrn(entityType, entityId),
        shareType: shareTypes[shareType] || shareType,
        isOwner: this.userIsOwner
      });
    };
  });

  Object.keys(organizeEvents).forEach(function(name) {
    var action = organizeEvents[name];

    /**
     * Triggers a specific clip organize event
     * @param {Array|Number} clipIds The clip id(s)
     * @param {Number|null} fromClipboardId The source clipboard id
     * @param {Number|null} toClipboardId The target clipboard id
     */
    ClippingTracker.prototype[name] = function(clipIds, fromClipboardId, toClipboardId) {
      return this.clipOrganizeAction({
        actionType: action.actionType,
        quantityType: action.quantityType,
        clipIds: $.isArray(clipIds) ? clipIds : [ clipIds ],
        sourceClipboardId: fromClipboardId,
        targetClipboardId: toClipboardId
      });
    };
  });

  Object.keys(clickEvents).forEach(function(name) {
    var action = clickEvents[name];

    /**
     * Triggers a specific click event
     * @param {Number|null} clipboardId An optional clipboard id
     * @param {Number|null} clipId An optional clip id
     */
    ClippingTracker.prototype[name] = function(clipboardId, clipId) {
      return this.track(events.SlideShareClippingClickEvent, {
        actionType: action,
        clipUrn: this.utils.getUrn(entityTypes.clip,  clipId),
        clipboardUrn: this.utils.getUrn(entityTypes.clipboard, clipboardId),
        isOwner: this.userIsOwner
      });
    };
  });

  ss.ClippingTracker = ClippingTracker;
})(window.slideshare_object);
